import i18n from 'i18next';

/**
 * 시간대·요일에 따른 랜덤 모임명 — 모임 생성 폼 초기값으로 사용.
 * 풀은 i18n(meetingName.*) 에서 현재 언어로 로드. 언어 변경 시 reload 되므로 충분.
 */
export const getRandomMeetingName = (now: Date = new Date()): string => {
    const day = now.getDay();
    const hour = now.getHours();
    const isWeekend = day === 0 || day === 6;
    const isFriday = day === 5;

    let key: string;
    if (hour >= 6 && hour < 11) key = isWeekend ? 'morningWeekend' : 'morningWeekday';
    else if (hour >= 11 && hour < 14) key = isWeekend ? 'lunchWeekend' : 'lunchWeekday';
    else if (hour >= 14 && hour < 17) key = isWeekend ? 'afternoonWeekend' : 'afternoonWeekday';
    else if (hour >= 17 && hour < 21) key = isFriday ? 'eveningFriday' : isWeekend ? 'eveningWeekend' : 'eveningWeekday';
    else if (hour >= 21 && hour < 24) key = isWeekend ? 'nightWeekend' : 'nightWeekday';
    else key = 'dawn';

    const raw = i18n.t('meetingName.' + key, { returnObjects: true });
    const pool: string[] = Array.isArray(raw) ? raw as string[] : ['\uBAA8\uC784'];
    return pool[Math.floor(Math.random() * pool.length)];
};

/**
 * 지금 계절에 맞는 여행 모임명 — 여행 모임 생성 폼 초기값.
 *
 * getRandomMeetingName 은 시간대·요일 풀이라 당일 모임용입니다. 여행에 쓰면
 * 2박 3일 일정에 "아침 한 잔" 이 들어갑니다.
 *
 * 여행지는 이 다음 단계에서 고르므로 목적지는 넣을 수 없습니다.
 * 풀이 비면 빈 문자열을 돌려주고, 부르는 쪽이 일반 이름으로 물러섭니다.
 */
export const getRandomTravelName = (now: Date = new Date()): string => {
    const m = now.getMonth() + 1;
    const season = m <= 2 || m === 12 ? 'winter'
        : m <= 5 ? 'spring'
            : m <= 8 ? 'summer' : 'autumn';

    const raw = i18n.t('meetingCreate.meetingNameTravelExamples.' + season, { returnObjects: true });
    const pool: string[] = Array.isArray(raw) ? raw as string[] : [];
    if (pool.length === 0) return '';
    return pool[Math.floor(Math.random() * pool.length)];
};
